import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { Root } from './ConflictTaskInfo.css';
import PageTitle from '../Layout/components/PageTitle';
import { Paper, Tabs, Tab, Table, TableHead, TableRow, Link, TableCell, TableBody, TableFooter, TablePagination, Button, Dialog, TextField, Breadcrumbs, Typography, Grid, FormControlLabel, Switch } from '@material-ui/core';
import { roleStr, defaultPageSize, isRole, ROLES, ADD, VIEW, EDIT, ONGOING, COMPLETED, DISABLED } from '../../common/common';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { BASE_URL } from '../../store/config';
import instance from '../../request/http';
import AlertDialog from '../Layout/components/AlertDialog';
import Search from '@material-ui/icons/Search'
import { getUrlParams, timeFormat } from '../../common/utils';
import PersonList from '../ConflictReport/components/PersonList';
import Toast from '../Layout/components/Toast';
import RichText from '../Components/RichText';

class ConflictTaskInfo extends PureComponent {
    constructor(props) {
        super(props);
        const id = getUrlParams("id");
        this.state = {
            id: id,
            tasksData: [{
                id: '1',
                name: 'zhangsan',
                description: 'ddd',
                principal_id: 'p',
                principal_name: 'p name',
                reference_number: '234',
                result: '',
                status: ONGOING,
                create_time: '',
                update_time: '',
            }],
            personsData: [{
                id: '1',
                person_name: '',
                relation: '',
                is_existed: '',
            }],
            result: {
                is_existed: false,
                note: '',
            },
            showToast: false,
            toastMsg: "",
            toastState: "",
        }
        this.handleCreate = this.handleCreate.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
        this.updateMember = this.updateMember.bind(this);
        this.handleAlias = this.handleAlias.bind(this);
    }
    render() {
        const { title, data, state } = this.props;
        const {
            id,
            tasksData,
            personsData,
            result,
            showToast,
            toastMsg,
            toastState,
        } = this.state;
        const noteView = () => {
            if (result.is_existed) {
                return <RichText
                    state={state}
                    data={result.note}
                    ref={(child) => { this.richText = child }}
                />
            }
        }
        const statusView = (status) => {
            if (status === ONGOING) {
                return <div className="basic-status color-1 c">Ongoing</div>
            } else if (status === COMPLETED) {
                return <div className="basic-status color-2 c">Completed</div>
            } else if (status === DISABLED) {
                return <div className="basic-status color-3 c">Disabled</div>
            } else {
                return <div>--</div>
            }
        }
        return (
            <Root>
                <div className="head h">
                    <div className="v">
                        <PageTitle subtitle="MANAGEMENT"></PageTitle>
                        <Breadcrumbs separator="›" aria-label="breadcrumb">
                            <Link className="title" onClick={() => this.props.history.goBack()}>All Task</Link>
                            <Typography className="crtTitle">{id}</Typography>
                        </Breadcrumbs>
                    </div>
                </div>
                <div className="content-wrap">
                    <div className="item-wrap">
                        <div className="title-2">Task Info</div>
                        <Table stickyHeader className="table">
                            <TableHead>
                                <TableRow role="checkbox">
                                    <TableCell>Reference Number</TableCell>
                                    <TableCell>Task Name</TableCell>
                                    <TableCell>Task desc</TableCell>
                                    <TableCell>Principal</TableCell>
                                    <TableCell>Status</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tasksData.map(row => (
                                    <TableRow key={row.principal_id} role="checkbox">
                                        <TableCell>{row.reference_number}</TableCell>
                                        <TableCell>{row.name}</TableCell>
                                        <TableCell>{row.description}</TableCell>
                                        <TableCell>{row.principal_name}</TableCell>
                                        <TableCell>{statusView(row.status)}</TableCell>
                                    </TableRow>
                                ))}
                                {tasksData.length === 0 && (
                                    <TableRow style={{ height: 300 }}>
                                        <TableCell colSpan={12} />
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </div>
                </div>
                <div className="content-wrap">
                    <div className="item-wrap">
                        <div className="title-2">Person List</div>
                        <Table stickyHeader className="table">
                            <TableHead>
                                <TableRow role="checkbox">
                                    <TableCell>Person Name</TableCell>
                                    <TableCell>Relation</TableCell>
                                    <TableCell>Email</TableCell>
                                    <TableCell>Phone</TableCell>
                                    <TableCell>Wechat</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {personsData.map((row, index) => (
                                    <TableRow key={index} role="checkbox">
                                        <TableCell>{row.full_name}</TableCell>
                                        <TableCell>{row.relation ? row.relation : "Client"}</TableCell>
                                        <TableCell>{row.email}</TableCell>
                                        <TableCell>{row.phone}</TableCell>
                                        <TableCell>{row.wechat}</TableCell>
                                    </TableRow>
                                ))}
                                {personsData.length === 0 && (
                                    <TableRow style={{ height: 300 }}>
                                        <TableCell colSpan={12} />
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </div>
                </div>
                <div className="content-wrap">
                    <div className="item-wrap">
                        <div className="title-2">Result</div>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={result.is_existed}
                                    onChange={this.handleAlias}
                                    name="is_existed"
                                    color="primary"
                                />
                            }
                            label="Existed"
                        />
                        {noteView()}
                    </div>
                </div>

                <div className="foot c">
                    <div className="h">
                        <Button
                            className="btn ml-10"
                            variant="contained"
                            color="primary"
                            onClick={e => this.handleCreate(e, ONGOING)}
                        >
                            save
                    </Button>
                        <Button
                            className="btn ml-10"
                            variant="contained"
                            color="primary"
                            onClick={e => this.handleCreate(e, COMPLETED)}
                        >
                            submit
                    </Button>
                    </div>
                </div>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
            </Root>
        )
    }
    componentDidMount() {
        const { id } = this.state;
        this.getTask(id, (data) => {
            this.initData(data);
        });
    }
    initData(data) {
        console.log(data)
        if (data) {
            const personsData = [data.client];
            personsData.push(...data.related_persons);
            console.log(personsData);
            this.setState({
                tasksData: [{
                    id: '1',
                    name: data.name,
                    description: data.description ? data.description : '',
                    principal_id: data.principal_id ? data.principal_id : '',
                    principal_name: data.principal_name ? data.principal_name : '',
                    reference_number: data.reference_number ? data.reference_number : '',
                    status: data.status ? data.status : ONGOING,
                    update_time: data.update_time ? data.update_time : '',
                }],
                personsData: personsData,
                result: data.result,
            })
        }
    }
    updateMember(member) {
        if (!member) return;
        const user_ids = [];
        user_ids.push(member.id);
        this.setState({
            user_ids
        })
    }
    handleAlias(event) {
        const isChecked = event.target.checked;
        this.setState((prevState) => ({
            result: {
                ...prevState.result,
                is_existed: isChecked,
            }
        }));
    }
    handleCreate(e, status) {
        const { id, result } = this.state;
        if (result.is_existed) {
            result.note = this.richText.getData();
        } else {
            result.note = "";
        }
        this.putTask(id, result, status);
        // this.props.handleCreate(result, status);
    }
    handleClose() {
        this.props.handleCancel();
    }
    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }
    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
    //------------request-----------------
    getTask(task_id, callback = null) {
        instance.get(BASE_URL + `conflict/task/${task_id}`).then((res) => {
            const taskData = res.data.data;
            console.log(taskData)
            if (callback) callback(taskData);
        })
    }
    putTask(task_id, result, status) {
        let params = {
            result,
            status,
        }
        instance.put(BASE_URL + `conflict/task/${task_id}`, params).then((res) => {
            console.log(res.data.data);
            if (status === ONGOING) {
                this.showToast("Saved successfully", "success");
            } else if (status === COMPLETED) {
                this.showToast("Submitted successfully", "success");
            }
            this.props.history.push("/main/conflictTask");
        })
    }
}

export default withRouter(ConflictTaskInfo);